import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkSlug from 'remark-slug';
import remarkGfm from 'remark-gfm'
import rehypeRaw from 'rehype-raw';

const MarkdownRenderer = ({ markdown }) => {
    return (
        <ReactMarkdown remarkPlugins={[remarkGfm]}  rehypePlugins={[rehypeRaw]} components={{
            section: (props) => {
                return (
                    <h1 id={props.node.properties.id}>
                        {props.children}
                    </h1>
            );
            },
        }}>{markdown}</ReactMarkdown>
    );
};

export default MarkdownRenderer;
